import { EP } from './../configs/constant';
import { getPath } from "../helpers/handleUrl";
import { IDistrictAddressResponse, IWardAddressResponse } from '../types/address';
import axiosService, { AxiosService } from './axiosService';
class AddressService {
    readonly service: AxiosService;
    constructor() {
        this.service = axiosService;
    }
    async getDistricts(provinceId: string) {
        return this.service.get<IDistrictAddressResponse>(getPath(EP.ADDRESS, EP.DISTRICT, {
            query: {
                [EP.PROVINCEID]: provinceId
            }
        }))
    }
    async getWards(province_code: string) {
        return this.service.get<IWardAddressResponse>("https://api.salekit.com:3039/api/v1/address/wards?province_code="+province_code)
    }
}
const addressService = new AddressService();
export default addressService;